

const _  = require('lodash');

const MONTHS = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'June',
  'July',
  'Aug',
  'Sept',
  'Oct',
  'Nov',
  'Dec'
];

const DataCaptureListPickerController = function ($scope) {

  /*eslint consistent-this: ["error", "vm"]*/
  const vm = this;

  vm.groups = [];

  vm.toggleGroup = (index) => {

    const datacapture = vm.groups[index];
    datacapture.collapse = !datacapture.collapse;
  };

  vm.handleDataCaptureSelected = (id) => {

    $scope.$emit('datacaptureSelected', {
      id
    });
  };

  const formatTime = (time) => {

    const hours = ('0' + time.getUTCHours()).slice(-2);
    const minutes = ('0' + time.getUTCMinutes()).slice(-2);
    return `${hours}:${minutes}`;
  };

  const _handleDataChanged = () => {

    if (vm.datacaptures.length === 0 || !vm.currentDatacapture) {
      return;
    }


    const datacaptures = vm.datacaptures.map((d) => {

      const datacapture = _.clone(d);
      datacapture.date = new Date(datacapture.capturedAt);
      datacapture.title = `${MONTHS[datacapture._localTimezoneCapturedAt.getUTCMonth()]}, ${datacapture._localTimezoneCapturedAt.getUTCDate()}`;
      datacapture.time = formatTime(datacapture._localTimezoneCapturedAt);
      datacapture.layers = {
        mesh_gltf: false,
        pc_rgb: false,
        tileLayer: false
      };
      datacapture.selected = vm.currentDatacapture.id === datacapture.id;

      datacapture.dataCaptureLayers.forEach((layer) => {

        datacapture.layers[layer.layerType] = true;
      });

      return datacapture;
    });

    datacaptures.reverse();

    const dcGroups = groupDatacaptures(datacaptures);
    vm.groups = dcGroups;
  };

  /**
   * @params {array} datacaptures
   */
  const groupDatacaptures = (datacaptures) => {

    let group = null;
    const groups = [];
    const currentDate =  datacaptures[0]._localTimezoneCapturedAt; // Get last datacapture

    datacaptures.forEach((datacapture) => {

      if (group !== null && (group.datacaptures.length === 1 || belongsTo(datacapture.date, group))) {
        // If the datacapture is selected uncollapse the current group
        if (datacapture.selected) {
          group.collapse = false;
        }

        group.datacaptures.push(datacapture);
        return;
      }

      group = makeCapturesGroup(datacapture.date, currentDate);
      groups.push(group);
      // If the datacapture is selected uncollapse the current group
      if (datacapture.selected) {
        group.collapse = false;
      }
      group.datacaptures.push(datacapture);
    });

    groups.forEach((group) => {

      group.title = group.year.toString();
      if (group.month !== null) {
        const lastMonth = group.datacaptures[0]._localTimezoneCapturedAt.getUTCMonth();
        const firstMonth = group.datacaptures[group.datacaptures.length - 1]._localTimezoneCapturedAt.getUTCMonth();

        if (firstMonth !== lastMonth) {
          group.title = MONTHS[firstMonth] + '-' + MONTHS[lastMonth];
        }
        else {
          group.title = MONTHS[group.month];
        }
      }
      else if (group.sixMonths) {
        group.title = 'Jan - June';
      }
      else {
        group.title = group.year.toString();
      }
    });

    return groups;
  };

  /**
   * @params {Date} currenDate - Date of the most recent datacapture
   * @params {Date} datacaptureDate - Date of the datacapture to group
   */
  const makeCapturesGroup = (datacaptureDate, currentDate) => {

    const dcYear = datacaptureDate.getFullYear();
    const dcMonth = datacaptureDate.getMonth();
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth();

    const group = {
      year: dcYear,
      month: null,
      sixMonths: false,
      collapse: true,
      datacaptures: []
    };

    // The datacapture is not in the current year
    // Group by year
    if (currentYear !== dcYear) {
      return group;
    }

    // If the current month is in the first six months of the year
    // Group the first six months of the year
    if (currentMonth >= 6 && dcMonth < 6) {
      group.sixMonths = true;
      return group;
    }

    // Else group by month
    group.month = dcMonth;
    return group;
  };

  /**
  * @params {Date} datacaptureDate
  * @params {Object} group - group of datacaptures
  * @params {number} group.month
  * @params {number} group.year
  * @return {boolean} - The datacapture should be added to the group
  */
  const belongsTo = (datacaptureDate, group) => {

    const year = datacaptureDate.getFullYear();
    const month = datacaptureDate.getMonth();

    return year === group.year && (
      (group.month === null && !group.halfYear) ||  // year group
      (month === group.month) ||              // month group
      (group.halfYear && month < 6)         // half year group
    );
  };

  $scope.$watch('vm.datacaptures', _handleDataChanged);
  $scope.$watch('vm.currentDatacapture', _handleDataChanged);
};

DataCaptureListPickerController.$inject = [
  '$scope'
];

module.exports = DataCaptureListPickerController;



// WEBPACK FOOTER //
// ./src/app/dash/topControls/dataCaptureSelector/dataCaptureListPicker/DataCaptureListPickerController.js